if (!customElements.get('wishlist-component')) {
  class WishlistComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.wishlistToggleButtons = document.querySelectorAll("[data-wishlist-toggle-button]");
      this.wishlistContainer = document.getElementById("wishlist-product-list");

      this.init();

      document.addEventListener('slider-element:loaded', () => {
        this.updateWishlistIcons();
      });
      
      document.addEventListener('product-info:loaded', () => {
        this.updateWishlistIcons();
      });

      document.addEventListener('collection:reloaded', () => {
        this.init();
      });
    }

    init() {
      this.updateWishlistUI();
      this.attachEventListeners();
    }

    attachEventListeners() {
      document.addEventListener("click", async (event) => {
        const button = event.target.closest("[data-wishlist-button]");
        if (button) {
          event.preventDefault();
          const productId = button.getAttribute("data-product-id");
          const variantId = button.getAttribute("data-variant-id");
          const url = button.getAttribute("data-product-url");
          const closeQuickview = button.getAttribute("data-close-quickview");
          const isInsideProductCard = button.closest(".product-card") !== null || button.closest(".product-form__wishlist") !== null;

          await this.toggleWishlistItem(productId, variantId, url);

          if (closeQuickview) {
            button.closest(".quick-view")?.querySelector(".button--close").click();
          }

          if (isInsideProductCard) {
            this.openWishlist();
          }
        }

        if (event.target.closest("[data-wishlist-clear]")) {
          this.clearWishlist();
        }
      });

      this.wishlistToggleButtons.forEach((button) => {
        button.addEventListener("click", () => this.openWishlist());
      });
    }

    getWishlist() {
      return JSON.parse(localStorage.getItem("wishlist")) || [];
    }

    saveWishlist(wishlist) {
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      this.updateWishlistIcons();
    }

    async toggleWishlistItem(productId, variantId, url) {
      let wishlist = this.getWishlist();
      const isInWishlist = wishlist.some((product) => product.id.toString() === productId.toString());

      wishlist = isInWishlist
        ? wishlist.filter((product) => product.id.toString() !== productId.toString())
        : [...wishlist, { id: productId.toString(), 'variantId': variantId.toString(), url }];

      this.saveWishlist(wishlist);
      await this.updateWishlistUI();
    }

    async updateWishlistUI() {
      if (!this.wishlistContainer) return;

      const wishlist = this.getWishlist();
      if (!wishlist.length) {
        this.wishlistContainer.innerHTML = `<p class="text-center py-8 text-gray-500">No products in your wishlist.</p>`;
        const clearButton = this.querySelector("[data-wishlist-clear]");
        if (clearButton) {
          clearButton.classList.add("hidden");
        }
      } else {
        this.wishlistContainer.innerHTML = '';
        const clearButton = this.querySelector("[data-wishlist-clear]");
        if (clearButton) {
          clearButton.classList.remove("hidden");
        }
      }

      for (const product of wishlist) {
        const url = new URL(product.url, window.location.origin);
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("section_id", "wishlist-product");
        const urlToFetch = `${url.origin}${url.pathname}?${searchParams.toString()}`;

        try {
          const response = await fetch(urlToFetch);
          const text = await response.text();
          const temp = document.createElement("div");
          temp.innerHTML = text;

          const section = temp.querySelector("#shopify-section-wishlist-product");
          if (section) {
            this.wishlistContainer.insertAdjacentHTML("beforeend", section.innerHTML);
          }
        } catch (error) {
          console.error(`Failed to fetch wishlist product ${product.id}:`, error);
        }
      }

      this.updateWishlistIcons();
    }

    updateWishlistIcons() {
      const wishlist = this.getWishlist();
      document.querySelectorAll("[data-wishlist-button]").forEach((button) => {
        const productId = button.getAttribute("data-product-id");
        const isInWishlist = wishlist.some((item) => item.id.toString() === productId.toString());
        this.updateWishlistButton(button, isInWishlist);
      });
    }

    updateWishlistButton(button, isInWishlist) {
      const iconName = isInWishlist ? "heart-filled" : "heart";
      button.innerHTML = `
        <span class="btn-fill" data-fill></span>
        <span class="btn-text">
          <svg class="icon icon--${iconName}" width="13" height="12" viewBox="0 0 13 12" stroke="currentColor" fill="none">
            ${isInWishlist
              ? `<path style="fill:#FF6647;" d="M6.5 1.03c-0.71-0.67-1.64-1.04-2.6-1.04-0.51 0-1.02 0.1-1.49 0.31-0.47 0.2-0.9 0.5-1.25 0.87C-0.38 2.75-0.38 5.21 1.15 6.78l4.78 4.89c0.11 0.2 0.32 0.34 0.57 0.34 0.1 0 0.2-0.03 0.29-0.08 0.09-0.05 0.17-0.12 0.23-0.2l4.83-4.94c1.53-1.57 1.53-4.03-0.01-5.61C11.49 0.8 11.06 0.5 10.59 0.3 10.12 0.1 9.61 0 9.1 0c-0.96 0-1.89 0.37-2.6 1.03z"/>`
              : `<path d="M6.5 1.03C5.79 0.37 4.86 0 3.9 0c-0.51 0-1.02 0.1-1.49 0.31-0.47 0.2-0.9 0.5-1.25 0.87C-0.38 2.75-0.38 5.21 1.15 6.78l4.78 4.89c0.11 0.2 0.32 0.34 0.57 0.34 0.1 0 0.2-0.03 0.29-0.08 0.09-0.05 0.17-0.12 0.23-0.2l4.83-4.94c1.53-1.57 1.53-4.03-0.01-5.61C11.49 0.8 11.06 0.5 10.59 0.3 10.12 0.1 9.61 0 9.1 0c-0.96 0-1.89 0.37-2.6 1.03z"/>`
            }
          </svg>
        </span>
      `;
    }

    openWishlist() {
      const cartDrawer = document.querySelector("#CartDrawer");
      if (!cartDrawer) return;
      cartDrawer.removeAttribute('hidden');
      cartDrawer.setAttribute('active', '');
      cartDrawer.setAttribute('open', '');
      cartDrawer.querySelector('#cartDrawerTabWishlist').click();
    }

    clearWishlist() {
      localStorage.removeItem("wishlist");
      this.updateWishlistUI();
    }
  }

  customElements.define("wishlist-component", WishlistComponent);
}
